export const GET_THREE_D_WIN_PERCENT_START='GET_THREE_D_WIN_PERCENT_START';
export const GET_THREE_D_WIN_PERCENT_SUCCESS='GET_THREE_D_WIN_PERCENT_SUCCESS';
export const GET_THREE_D_WIN_PERCENT_FAIL='GET_THREE_D_WIN_PERCENT_FAIL';

export const UPDATE_THREE_D_WIN_PERCENT_START='UPDATE_THREE_D_WIN_PERCENT_START';
export const UPDATE_THREE_D_WIN_PERCENT_SUCCESS='UPDATE_THREE_D_WIN_PERCENT_SUCCESS';
export const UPDATE_THREE_D_WIN_PERCENT_FAIL='UPDATE_THREE_D_WIN_PERCENT_FAIL';

export const TOGGLE_THREE_D_WIN_PERCENT_UPDATE='TOGGLE_THREE_D_WIN_PERCENT_UPDATE';